import { RootState } from '@reducers';

export const selectInsuranceClaimListPageReducer = (state: RootState) => state.userDashboardRouteReducer.insuranceClaimListPageReducer;
